import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DiscussionsService } from '../../../services/discussions.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";

export interface DiscussionData {
    discussionId: string;
    ownerName: string;
    ownerId: string;
    title: string;
    viewsCount: string;
    category: string;
    createdDate: string;
    answersCount: string;
}

@Component({
  selector: 'app-discussions-all',
  templateUrl: './discussions-all.component.html',
  styleUrls: ['./discussions-all.component.scss']
})
export class DiscussionsAllComponent implements AfterViewInit {
    displayedColumns: string[] = ['discussion'];
    dataSource: MatTableDataSource<DiscussionData>;

    @ViewChild(MatPaginator)
    paginator!: MatPaginator;
    @ViewChild(MatSort)
    sort!: MatSort;

    discussions: Array<DiscussionData> = [];
    loadingMessage: string = "Loading...";

    pagecode: string = "disc-all";
    module: string = "discussion";

    accessdenied: boolean = false;

    discussionCategories: any = [
        {
            "name": "All",
            "code": "all",
            "isActive": true,
            "active_background_color": "#00a6b6",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "#00a6b6"
        },
        {
            "name": "Technical",
            "code": "technical",
            "isActive": false,
            "active_background_color": "#00a6b6",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "#00a6b6"
        },
        {
            "name": "General",
            "code": "general",
            "isActive": false,
            "active_background_color": "#00a6b6",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "#00a6b6"
        }

    ];

    applyCategoryFilter(categoryCode: any) {
        if (categoryCode === 'all') {
            this.dataSource = new MatTableDataSource(this.discussions);
        }
        else {
            var filteredArray: DiscussionData[] = this.discussions.filter(s => s.category.toLowerCase().includes(categoryCode));
            this.dataSource = new MatTableDataSource(filteredArray);
        }

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        for (var i = 0; i < this.discussionCategories.length; i++) {
            if (this.discussionCategories[i].code === categoryCode)
                this.discussionCategories[i].isActive = true;
            else
                this.discussionCategories[i].isActive = false;
        }

    }

    constructor(private route: ActivatedRoute, private _router: Router, private discussionService: DiscussionsService, private authentication: AuthenticationService, private common: CommonService) {

        this.dataSource = new MatTableDataSource(this.discussions);

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {


                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        // load page data
                        this.getDiscussions(1);
                        //
                    }
                    else
                        this.accessdenied = true;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });

    }

    getDiscussions(page: any) {
        this.discussionService.getDiscussions(page).subscribe(
            (res: any) => {
                if (res.success) {
                    for (var i = 0; i < res.data.length; i++) {
                        this.discussions.push({
                            discussionId: res.data[i].discussionId,
                            ownerName: res.data[i].owner.firstName + ' ' + res.data[i].owner.lastName,
                            ownerId: res.data[i].owner_PortalUserId,
                            title: res.data[i].title,
                            viewsCount: res.data[i].viewsCount,
                            category: res.data[i].category,
                            createdDate: res.data[i].createdDate,
                            answersCount: res.data[i].answersCount
                        });
                    }
                    this.dataSource = new MatTableDataSource(this.discussions);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                    this.loadingMessage = "No data found";

                    if (res.data.length > 0)
                        this.getDiscussions(page + 1);

                }
                else {
                    console.error("Web/Discussions/All/getDiscussions()", res.error_message);
                }

            },
            (err: any) => {
                console.error("Web/Discussions/All/getDiscussions()", err);
            }
        );
    }
    clickedRows(row: any) {
        this._router.navigate(['/discussion/detail/' + row.discussionId]);
    }
    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

}
